import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    tab: 0,
    mnrTab: 0,
    reportsTab: 0,
    cocaAnnualTab: 0
}

const tabIndexSlice = createSlice({
    name: 'tab',
    initialState,
    reducers: {
        currentTabIndex: (state, action) => {
            state.tab = action.payload
        },
        mnrTabIndex: (state, action) => {
            state.mnrTab = action.payload
        },
        reportsTabIndex: (state, action) => {
            state.reportsTab = action.payload
        },
        cocaAnnualTabIndex: (state, action) => {
            state.cocaAnnualTab = action.payload
        }
    }
})

export const { currentTabIndex, mnrTabIndex, reportsTabIndex, cocaAnnualTabIndex } = tabIndexSlice.actions;
export default tabIndexSlice.reducer;